<app-loader></app-loader>
<app-header *ngIf="showHead"></app-header>
<router-outlet></router-outlet>
<app-footer *ngIf="showHead" ></app-footer>
